import { render, staticRenderFns } from "./async_block.vue?vue&type=template&id=09297b6a&scoped=true&"
import script from "./async_block.vue?vue&type=script&lang=js&"
export * from "./async_block.vue?vue&type=script&lang=js&"
import style0 from "./async_block.vue?vue&type=style&index=0&id=09297b6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09297b6a",
  null
  
)

export default component.exports